import { useState, useEffect } from "react";
import SaveDoc from "../elements/SaveDoc";
import { deleteUserFile, fetchUserFiles, fetchAllFiles } from "../utils/sheets";
import Menu from "../elements/Menu";
import {
  IonCardSubtitle,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonItem,
  IonItemGroup,
  IonPage,
  IonRow,
  IonButton,
  useIonToast,
} from "@ionic/react";
import { eye, cloudDownload, trash } from "ionicons/icons";

export default function Home({ user }) {
  const [files, setFiles] = useState([]);
  const [groupedFiles, setGroupedFiles] = useState([]);
  const [presentToast] = useIonToast();

  const reloadFiles = async () => {
    if (user.role === "mestre") {
      const allFiles = await fetchAllFiles();
      setGroupedFiles(allFiles);
    } else {
      const userFiles = await fetchUserFiles(user.uid);
      setFiles(userFiles);
    }
  };

  useEffect(() => {
    reloadFiles();
  }, [user]);

  return (
    <IonPage className="gray-page">
      <Menu title="Cursed Nights" />
      <IonContent>
        <IonGrid>
          <IonRow>
            <IonCol>
              <SaveDoc username={user.name} onUpload={() => reloadFiles()} />
            </IonCol>
          </IonRow>

          {user.role === "mestre" ? (
            groupedFiles.map((file) => (
              <IonRow key={file.path}>
                <IonCol>
                  {file.user && (
                    <IonCardSubtitle>Jogador: {file.user}</IonCardSubtitle>
                  )}
                  <IonItemGroup>
                    <IonItem key={file.path}>
                      {file.name}
                      <IonButton
                        fill="clear"
                        slot="end"
                        href={file.url}
                        target="_blank"
                      >
                        <IonIcon icon={eye} />
                      </IonButton>
                      <IonButton
                        fill="clear"
                        slot="end"
                        href={file.url}
                        download={file.name}
                        target="_blank"
                      >
                        <IonIcon icon={cloudDownload} />
                      </IonButton>
                      <IonButton
                        fill="clear"
                        slot="end"
                        color="danger"
                        onClick={() =>
                          deleteUserFile(file.path, reloadFiles, presentToast)
                        }
                      >
                        <IonIcon icon={trash} />
                      </IonButton>
                    </IonItem>
                  </IonItemGroup>
                </IonCol>
              </IonRow>
            ))
          ) : (
            <>
              <IonRow>
                <IonCol>
                  <IonCardSubtitle>Meus Arquivos</IonCardSubtitle>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol>
                  <IonItemGroup>
                    {files.length
                      ? files.map((file) => (
                          <IonItem key={file.path}>
                            {file.name}
                            <IonButton
                              fill="clear"
                              slot="end"
                              href={file.url}
                              target="_blank"
                            >
                              <IonIcon icon={eye} />
                            </IonButton>
                            <IonButton
                              fill="clear"
                              slot="end"
                              href={file.url}
                              download={file.name}
                              target="_blank"
                            >
                              <IonIcon icon={cloudDownload} />
                            </IonButton>
                            <IonButton
                              fill="clear"
                              slot="end"
                              color="danger"
                              onClick={() =>
                                deleteUserFile(file.path, reloadFiles)
                              }
                            >
                              <IonIcon icon={trash} />
                            </IonButton>
                          </IonItem>
                        ))
                      : "Você não tem arquivos"}
                  </IonItemGroup>
                </IonCol>
              </IonRow>
            </>
          )}
        </IonGrid>
      </IonContent>
    </IonPage>
  );
}
